import React, { useMemo } from 'react';

import { Icon } from '@/utils/icons';

interface RatingStarsProps {
  rating: number;
  maxRating?: number;
  size?: number;
  className?: string;
}

const RatingStars: React.FC<RatingStarsProps> = ({
  rating,
  maxRating = 5,
  size = 14,
  className = '',
}) => {
  const stars = useMemo(() => Array.from({ length: maxRating }, (_, i) => i + 1), [maxRating]);

  return (
    <div
      className={`flex items-center gap-0.5 ${className}`}
      role="img"
      aria-label={`Rating: ${rating} out of ${maxRating} stars`}>
      {stars.map(i => {
        const isFull = i <= Math.floor(rating);
        const isHalf = !isFull && i - rating < 1;

        return (
          <Icon
            key={i}
            name="Star"
            size={size}
            aria-hidden="true"
            className={
              isFull
                ? 'fill-secondary-400 text-secondary-400'
                : isHalf
                  ? 'fill-secondary-400/50 text-secondary-400'
                  : 'text-neutral-200'
            }
          />
        );
      })}
    </div>
  );
};

export default React.memo(RatingStars);
